{
  "generic": {
    "no": "Nej",
    "yes": "Ja",
    "text": "Text "
  },
  "consent": {
    "defaultLabelText": "Genom att skicka in detta formulär godkänner du vår ",
    "defaultLabelLink": "integritetspolicy"
  },
  "text": {
    "defaultHeadlineText": "Detta är en rubrik",
    "defaultText": "Detta är ett textblock",
    "floatingDefaultText": "NYTT!"
  },
  "button": {
    "submitDefaultText": "Skicka",
    "instagramDefaultText": "Följ oss",
    "defaultText": "Klicka här",
    "closing": "STÄNGER..."
  },
  "input": {
    "emailLabel": "E-post",
    "emailPlaceholder": "Ange din e-postadress",
    "passwordLabel": "Lösenord",
    "passwordPlaceholder": "Ange lösenord",
    "nameLabel": "Namn",
    "namePlaceholder": "Ange ditt namn",
    "firstNameLabel": "Förnamn",
    "firstNamePlaceholder": "Ange förnamn",
    "lastNameLabel": "Efternamn",
    "lastNamePlaceholder": "Ange efternamn",
    "phoneLabel": "Telefon",
    "phonePlaceholder": "Ange telefonnummer",
    "textareaLabel": "Meddelande",
    "textareaPlaceholder": "Ange ditt meddelande",
    "regularLabel": "Text",
    "regularPlaceholder": "Ange text",
    "defaultLabel": "Etikett",
    "defaultPlaceholder": "Platshållare",
    "datePlaceholder": "Välj datum",
    "stepLabel": "Skriv din fråga här"
  },
  "dropdown": {
    "placeholder": "Välj ett alternativ",
    "firstItem": "Alternativ 1",
    "secondItem": "Alternativ 2",
    "chooseCountry": "Land"
  },
  "buttonList": {
    "firstItem": "Alternativ 1",
    "secondItem": "Alternativ 2",
    "option1": "Val 1",
    "option2": "Val 2",
    "option3": "Val 3",
    "subscriptionItem1": "Nyhetsbrev",
    "subscriptionItem2": "Uppdateringar",
    "chooseSubscriptionTopics": "Välj prenumerationsämnen",
    "other": "Annan",
    "uncheck-all-label": "Jag vill inte ta emot några av dessa e-postmeddelanden"
  },
  "rating": {
    "rateLabel": "Betygsätt oss",
    "npsLabel": "Hur troligt är det att du rekommenderar oss?",
    "veryUnsatisfied": "Mycket missnöjd",
    "unsatisfied": "Missnöjd",
    "neutral": "Neutral",
    "satisfied": "Nöjd",
    "loveIt": "Älskar det!",
    "minValueLabel": "Låg",
    "maxValueLabel": "Hög",
    "minValueLabelNps": "Inte troligt",
    "maxValueLabelNps": "Mycket troligt"
  },
  "deadline": {
    "days": "Dagar",
    "hours": "Timmar",
    "minutes": "Minuter",
    "seconds": "Sekunder"
  },
  "bulletList": {
    "firstItem": "Fördel 1",
    "secondItem": "Fördel 2"
  },
  "discountCode": {
    "copyMessage": "Kopierat till urklipp!",
    "fallback": "WELCOME10",
    "textDefault": "Din rabattkod",
    "buttonDefault": "Kopiera"
  },
  "share": {
    "buttonText": "Dela"
  },
  "common": {
    "label": "Etikett"
  },
  "wcag": {
    "banner": "Kampanjbanner",
    "closeButton": "Stäng",
    "submitButton": "Skicka formulär"
  },
  "spinTheWheel": {
    "prizeWonText": "Grattis!",
    "prizeWonButtonText": "Hämta ditt pris",
    "prizeLostText": "Åhh, synd! :-(",
    "prizeLostButtonText": "Klicka för att stänga",
    "spinButtonLabel": "SNURRA"
  },
  "memory": {
    "resultWonText": "Bra jobbat! Din tid var {elapsedTime}",
    "resultWonButtonText": "Hämta ditt pris"
  },
  "stepNavigation": {
    "nextButtonText": "Nästa",
    "previousButtonText": "Tillbaka",
    "lastButtonText": "Stäng",
    "submitButtonText": "Skicka"
  },
  "defaultRealTimeMessage": {
    "validationError": "Vänligen kontrollera formatet på informationen du skickade in.",
    "unknownError": "Ett oväntat fel uppstod.",
    "conflictError": "Denna användare finns redan.",
    "success": "Formuläret skickades."
  }
}
